var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{class:_vm.classes,domProps:{"innerHTML":_vm._s(_vm.snackbar.message)}})
}
var staticRenderFns = []

export { render, staticRenderFns }